<template>
  <BasicButton
    @click="toggleAnalytics"
    title="Статистика"
    appearance="icon-only"
  >
    <SvgIcon
      icon="stats"
      size="24"
      :source="$options.icons"
      class="response-analytics-button__icon"
    />
  </BasicButton>
</template>

<script>
import { VacanciesResponsesSourcesResource } from 'src/services/vacancies.js';

import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

export default {
  name: 'ResponseAnalyticsButton',

  icons: '/images/responses-v3.svg',

  components: {
    SvgIcon,
    BasicButton,
  },

  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
    responseId: {
      type: Number,
      required: true,
    },
  },

  emits: ['responseAnalytics'],

  data() {
    return {
      showAnalytics: false,
    };
  },

  methods: {
    responsesSourcesGet: VacanciesResponsesSourcesResource.get,

    toggleAnalytics() {
      if (!this.showAnalytics) {
        this.responsesSourcesGet({
          vacancyId: this.vacancyId,
          responseId: this.responseId,
        }).then(({ data }) => {
          this.showAnalytics = true;
          this.$emit('responseAnalytics', {
            responseId: this.responseId,
            data: data.analytics,
          });
        });
      } else {
        this.showAnalytics = false;
        this.$emit('responseAnalytics', {
          responseId: this.responseId,
          data: null,
        });
      }
    },
  },
};
</script>
